export interface Feature {
   name: string;
}
